import React from 'react'
import { OverlayTrigger, Tooltip, Table } from 'react-bootstrap'
const GroupCommunity = ({
  totalFBFanPercentage,
  totalIGFanPercentage,
  totalYTFanPercentage,
}) => {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      這個指標能夠告訴您旗下所有子品牌/企業，在一定時間內社群帳號的粉絲數量增加的百分比，不同社群來原為一個平均值。
    </Tooltip>
  )

  return (
    <>
      <Table striped hover className="mt-0">
        <thead>
          <tr>
            <th scope="col" className="fs-5">
              <h4 className="fw-bolder ">
                全品牌漲粉率
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 50, hide: 400 }}
                  overlay={renderTooltip}
                >
                  <div
                    className="fas fa-question-circle p-1 text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                  ></div>
                </OverlayTrigger>
              </h4>
            </th>
          </tr>
        </thead>
        <tbody className="table-group-divider">
          <tr>
            <th scope="row">FB 漲粉率</th>
            <td>{totalFBFanPercentage} %</td>
          </tr>
          <tr>
            <th scope="row">IG 漲粉率</th>
            <td>{totalIGFanPercentage} %</td>
          </tr>
          <tr>
            <th scope="row">YT 漲粉率</th>
            <td>{totalYTFanPercentage} %</td>
          </tr>
        </tbody>
      </Table>
    </>
  )
}

export default GroupCommunity
